<template>
  <div class="flex-between">
    <div class="charts-box" @click="goGraph('/zxk/search/enterpriseGraph')">
      <img src="https://public-oss.qizhidao.com/APP/202309/c7aa154aa91f4be7a14b7698e2249847.png" alt="企业图谱" class="charts-img">
      <p class="title">企业架构图</p>
    </div>
    <div class="charts-box" @click="goGraph('/zxk/search/equityPenetration')">
      <img src="https://public-oss.qizhidao.com/APP/202309/7ccd035833144a40af601448796ebec3.png" alt="股权穿透图" class="charts-img">
      <p class="title">股权全景穿透</p>
    </div>
    <!-- <div class="charts-box" @click="goGraph('/zxk/search/enterpriseGraph')">
      <img src="https://public-oss.qizhidao.com/APP/202403/132ecd237bd44d869705f16a6e03f7c7.png" alt="产业图谱" class="charts-img">
      <p class="title">产业图谱</p>
    </div> -->
    <div class="charts-box" @click="goGraph('/zxk/search/shareholderStructure')">
      <img src="https://public-oss.qizhidao.com/APP/202309/8cd3669ef9be4c9996e9ad4c341e4011.png" alt="股权结构图" class="charts-img">
      <p class="title">股东持股穿透</p>
    </div>
    <div class="charts-box" @click="goGraph('/zxk/search/investmentPenetration')">
      <img src="https://public-oss.qizhidao.com/APP/202309/8cd3669ef9be4c9996e9ad4c341e4011.png" alt="股权结构图" class="charts-img">
      <p class="title">对外投资穿透</p>
    </div>
    <!-- <div class="charts-box">
      <img src="https://public-oss.qizhidao.com/APP/202309/ee0135fdaaa9468faeb8a471ca447674.png" alt="企业受益股东" class="charts-img">
      <p class="title">企业受益股东</p>
    </div>
    <div class="charts-box">
      <img src="https://public-oss.qizhidao.com/APP/202309/99545a0f56c44a5c8b264c16115d4198.png" alt="关联方认定图" class="charts-img">
      <p class="title">关联方认定图</p>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'EnterpriseGraphTab',
  components: {

  },
  props: {

  },
  inject: ['$companyStatus'],
  data() {
    return {

    }
  },
  mounted() {
    // console.log(1, this.$companyStatus);
  },
  methods: {
    goGraph(path) {
      const { hid, companyName } = this.$companyStatus
      const routeUrl = this.$router.resolve({
        path,
        query: { hid, companyName }
      })
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.charts-title {
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  color: #292a2d;
  font-weight: 700;
  text-align: left;
}

.flex-between {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.flex-between div + div {
  margin-left: 20px;
}

.flex-between .charts-box {
  text-align: center;
  font-size: 0;
  cursor: pointer;
  position: relative;
}

.flex-between .charts-box:hover .charts-img {
  border-color: #3981f4;
}

.flex-between .charts-box:hover .title {
  color: #3981f4;
}

.flex-between .charts-box .new_icon {
  position: absolute;
  left: 0;
  top: 0;
  width: 34px;
  height: 20px;
}

.flex-between .charts-box .charts-img {
  width: 122px;
  height: 80px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
}

.flex-between .charts-box .title {
  font-size: 14px;
  color: #292a2d;
  font-weight: 400;
  margin-top: 12px;
}
</style>
